<div class="modal" tabindex="-1" #modal>
  <div class="modal-dialog" [ngClass]="getClasses()">
    <div class="modal-content">
      <ng-template #container>
      </ng-template>
    </div>
  </div>
</div>
